<script>
	import { onMount } from "svelte";

	import Checkbox from "./Checkbox.svelte";
	import Input from "./Input.svelte";
	import TextArea from "./TextArea.svelte";

	export let name = null;
	export let disabled = null;
	export let required = null;
	export let validator = "checkboxRequired";
	export let validatorValue = null;
	export let validatorMessage = null;
	export let validatorTarget = ".checkbox-error";

	export let cols = "12";
	export let options = [];
	export let selectedOptions = [];
	export let useOther = false;
	export let otherOptionValue = null;
	export let maxLengthOther = null;
	export let otherLabel = null;
	export let otherInputType = "input";

	let otherValue = null;

	let otherIndex = -1;
	if (useOther) {
		otherIndex = options.findIndex((object) => {
			return object.value === otherOptionValue;
		});
	}

	if (selectedOptions && selectedOptions.length) {
		options.forEach((o) => {
			o.checked = selectedOptions.findIndex((s) => s.Name === o.value) > -1;
		});

		if (useOther && otherIndex >= 0 && options[otherIndex].checked) {
			let selectedOtherIndex = selectedOptions.findIndex((s) => s.Name === otherOptionValue);
			if (selectedOtherIndex >= 0) {
				otherValue = selectedOptions[selectedOtherIndex].OtherName;
			}
		}
	}

	const handleChange = (e) => {
		if (e.target.checked) {
			if (selectedOptions.findIndex((s) => s.Name === e.target.value) == -1) {
				selectedOptions.push({ Name: e.target.value });
			}
		} else {
			let index = selectedOptions.findIndex((object) => object.Name === e.target.value);
			if (index > -1) {
				selectedOptions.splice(index, 1);
			}
		}
	};

	const handleOtherChange = (e) => {
		if (useOther && otherIndex >= 0 && options[otherIndex].checked) {
			populateOtherName(e.target.value);
			let selectedOtherIndex = selectedOptions.findIndex((s) => s.Name === otherOptionValue);
			if (selectedOtherIndex >= 0) {
				selectedOptions[selectedOtherIndex].OtherName = e.target.value;
			}
		}
	};

	const populateOtherName = (name) => {
		let selectedOtherIndex = selectedOptions.findIndex((s) => s.Name === otherOptionValue);
		if (selectedOtherIndex >= 0) {
			selectedOptions[selectedOtherIndex].OtherName = name;
		}
	};

	onMount(() => {
		selectedOptions = selectedOptions || [];
	});
</script>

{#each options as option, i}
	<div class="form-group col-md-{cols} form-inline checkbox-cell">
		<Checkbox
			{validator}
			{validatorValue}
			{validatorMessage}
			{validatorTarget}
			{disabled}
			bind:checked={option.checked}
			value={option.value}
			label={option.label}
			{name}
			id="{name}{i}"
			on:change={(e) => handleChange(e)}
		></Checkbox>
	</div>
	{#if useOther && otherIndex >= 0 && options[otherIndex].checked && otherIndex == i}
		<div>
			{#if otherInputType !== "input"}
				<TextArea
					{disabled}
					{required}
					label={otherLabel}
					maxlength={maxLengthOther}
					id="other_{name}"
					name="other_{name}"
					bind:value={otherValue}
					autoExpand={true}
					on:change={(e) => handleOtherChange(e)}
				/>
			{:else}
				<Input
					{disabled}
					{required}
					maxlength={maxLengthOther}
					label={otherLabel}
					bind:value={otherValue}
					id="other_{name}"
					on:change={(e) => handleOtherChange(e)}
				/>
			{/if}
		</div>
	{/if}
{/each}
<div class="checkbox-error"></div>

<style>
	.checkbox-cell {
		height: 35px;
	}
</style>
